const counters = document.querySelectorAll(".counter");

counters.forEach((counter) => {
  counter.innerText = "0+";
  const updateCounter = () => {
    const target = +counter.getAttribute("data-target");
    const currentText = counter.innerText.replace('+', '').replace(',', '');
    const count = +currentText;
    const increment = target / 500;
    
    if (count < target) {
      const newVal = Math.ceil(count + increment);
      counter.innerText = `${newVal}+`;
      setTimeout(updateCounter, 1);
    } else {
      counter.innerText = `${target}+`; // Final value with +
    }
  };
  updateCounter();
});


document.addEventListener('DOMContentLoaded', function () {
    const tabs = document.querySelectorAll('.tab-menu li');
    const contents = document.querySelectorAll('.tab-content');

    tabs.forEach(tab => {
      tab.addEventListener('click', function () {
        const tabId = this.getAttribute('data-tab');

        tabs.forEach(t => t.classList.remove('active'));
        contents.forEach(c => c.classList.remove('active'));

        this.classList.add('active');
        document.getElementById(tabId).classList.add('active');
      });
    });
  });

var swiper = new Swiper('.powerhouse_swiper', {
  // Default parameters
  slidesPerView: 1,
  spaceBetween: 10,
  clickable: true,
  breakpoints: {
    750: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
       990: {
      slidesPerView: 3,
      spaceBetween: 30
    },   
    
  }
});

 document.addEventListener("DOMContentLoaded", function () {
    var swiper = new Swiper(".about_swiper", {
      slidesPerView: 1,
      spaceBetween: 250,
      centeredSlides: true,
      loop: true,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  });


$('#chooseFile').bind('change', function () {
  var filename = $("#chooseFile").val();
  if (/^\s*$/.test(filename)) {
    $(".file-upload").removeClass('active');
    $("#noFile").text("No file chosen..."); 
  }
  else {
    $(".file-upload").addClass('active');
    $("#noFile").text(filename.replace("C:\\fakepath\\", "")); 
  }
});

